import { applicantGenerateDocsRequests } from "@/src/api/applicantGenerateDocsRequests";

const normalizeSeria = (value: string | null | undefined): string => String(value ?? "").trim();

const findApplicantGenerateDocIdBySeria = async (
  documentSeria: string,
  applicantId?: number,
): Promise<number | null> => {
  const seria = normalizeSeria(documentSeria);
  if (!seria) return null;

  const pageSize = 200;
  let offset = 0;

  for (;;) {
    const listed = await applicantGenerateDocsRequests.list({
      ...(applicantId != null ? { applicant_id: applicantId } : {}),
      limit: pageSize,
      offset,
    });

    const rows = listed?.data ?? [];
    const match = rows.find((item) => normalizeSeria(item.document_seria) === seria);
    if (typeof match?.id === "number" && match.id >= 1) {
      return match.id;
    }

    const total = listed?.count ?? rows.length;
    offset += pageSize;
    if (rows.length < pageSize || offset >= total) {
      break;
    }
  }

  return null;
};

/**
 * Resolves applicant-generate-docs row id (by explicit id or by document_seria + optional applicant_id)
 * and deletes it. No-ops when the link cannot be resolved.
 */
export const resolveAndDeleteApplicantGenerateDoc = async (options: {
  id?: number | null;
  applicantId?: number | null;
  documentSeria?: string | null;
}): Promise<boolean> => {
  let targetId =
    typeof options.id === "number" && Number.isFinite(options.id) && options.id >= 1
      ? options.id
      : null;

  if (targetId == null) {
    const applicantId =
      typeof options.applicantId === "number" && Number.isFinite(options.applicantId) && options.applicantId >= 1
        ? options.applicantId
        : undefined;
    targetId = await findApplicantGenerateDocIdBySeria(options.documentSeria ?? "", applicantId);
  }

  if (targetId == null) return false;

  const deleted = await applicantGenerateDocsRequests.delete(targetId);
  return deleted != null;
};
